module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_9016.b490e4e7.png";